import { ScopeHierarchy, ScopeHierarchyId } from "Shared/Components/Scope/Scopes.types";
import { EnvironmentDefault, RingDefault } from "./SubstrateScopeNodeDefaults";

const machineScope = {
    ScopeType: "Machine",
    MaasScopeType: "ExoMachine",
    DisplayName: "Machine"
};

const capacityUnitScope = {
    ScopeType: "CapacityUnit",
    MaasScopeType: "ExoCapacityUnit",
    DisplayName: "CapacityUnit",
    ChildScopes: [machineScope]
};

const locationScope = {
    ScopeType: "Location",
    MaasScopeType: "ExoLocation",
    DisplayName: "Location",
    ChildScopes: [capacityUnitScope]
};

const forestScope = {
    ScopeType: "Forest",
    MaasScopeType: "ExoForest",
    DisplayName: "Forest",
    ChildScopes: [capacityUnitScope]
};

const faultZoneScope = {
    ScopeType: "FaultZone",
    MaasScopeType: "ExoFaultZone",
    DisplayName: "FaultZone",
    DefaultValue: "All",
    ChildScopes: [forestScope, locationScope]
};

const regionScope = {
    ScopeType: "Region",
    MaasScopeType: "ExoRegion",
    DisplayName: "Region",
    DefaultValue: "All",
    ChildScopes: [faultZoneScope]
};

const ringScope = {
    ScopeType: "Ring",
    MaasScopeType: "ExoRing",
    DisplayName: "Ring",
    DefaultValue: RingDefault,
    ChildScopes: [regionScope]
};

export const SubstrateCafeScopeHierarchy: ScopeHierarchy = {
    HierarchyId: ScopeHierarchyId.SubstrateCafeScopeHierarchy,
    DisplayName: "CAFE",
    Root: {
        ScopeType: "Environment",
        MaasScopeType: "ExoEnvironment",
        DisplayName: "Environment",
        DefaultValue: EnvironmentDefault,
        ChildScopes: [ringScope]
    }
};

export const SubstrateLogicalScopeHierarchy: ScopeHierarchy = {
    HierarchyId: ScopeHierarchyId.SubstrateLogicalScopeHierarchy,
    DisplayName: "Logical",
    Root: {
        ScopeType: "Environment",
        MaasScopeType: "ExoEnvironment",
        DisplayName: "Environment",
        DefaultValue: EnvironmentDefault,
        ChildScopes: [
            {
                ScopeType: "Ring",
                MaasScopeType: "ExoRing",
                DisplayName: "Ring",
                DefaultValue: RingDefault,
                ChildScopes: [
                    {
                        ScopeType: "Region",
                        MaasScopeType: "ExoRegion",
                        DisplayName: "Region",
                        ChildScopes: [
                            {
                                ScopeType: "Forest",
                                MaasScopeType: "ExoForest",
                                DisplayName: "Forest",
                                ChildScopes: [
                                    {
                                        ScopeType: "Dag",
                                        MaasScopeType: "ExoDAG",
                                        DisplayName: "Dag",
                                        ChildScopes: [
                                            {
                                                ScopeType: "Machine",
                                                MaasScopeType: "ExoMachine",
                                                DisplayName: "Machine"
                                            }
                                        ]
                                    }
                                ]
                            }
                        ]
                    }
                ]
            }
        ]
    }
};

export const SubstrateAccountForestScopeHierarchy: ScopeHierarchy = {
    HierarchyId: ScopeHierarchyId.SubstrateAccountForestScopeHierarchy,
    DisplayName: "Account forest",
    Root: {
        ScopeType: "Environment",
        MaasScopeType: "ExoEnvironment",
        DisplayName: "Environment",
        DefaultValue: EnvironmentDefault,
        ChildScopes: [
            {
                ScopeType: "Ring",
                MaasScopeType: "ExoRing",
                DisplayName: "Ring",
                DefaultValue: RingDefault,
                ChildScopes: [
                    {
                        ScopeType: "Region",
                        MaasScopeType: "ExoRegion",
                        DisplayName: "Region",
                        ChildScopes: [
                            {
                                ScopeType: "AccountForest",
                                MaasScopeType: "ExoAccountForest",
                                DisplayName: "Account forest"
                            }
                        ]
                    }
                ]
            }
        ]
    }
};

export const SubstratePhysicalScopeHierarchy: ScopeHierarchy = {
    HierarchyId: ScopeHierarchyId.SubstratePhysicalScopeHierarchy,
    DisplayName: "Physical",
    Root: {
        ScopeType: "Environment",
        MaasScopeType: "ExoEnvironment",
        DisplayName: "Environment",
        DefaultValue: EnvironmentDefault,
        ChildScopes: [
            {
                ScopeType: "Ring",
                MaasScopeType: "ExoRing",
                DisplayName: "Ring",
                DefaultValue: RingDefault,
                ChildScopes: [
                    {
                        ScopeType: "Region",
                        MaasScopeType: "ExoRegion",
                        DisplayName: "Region",
                        ChildScopes: [
                            {
                                ScopeType: "Location",
                                MaasScopeType: "ExoLocation",
                                DisplayName: "Datacenter",
                                ChildScopes: [
                                    {
                                        ScopeType: "Rack",
                                        MaasScopeType: "ExoRack",
                                        DisplayName: "Rack"
                                    },
                                    {
                                        ScopeType: "LoadBalancer",
                                        MaasScopeType: "ExoLoadBalancer",
                                        DisplayName: "LoadBalancer"
                                    }
                                ]
                            }
                        ]
                    }
                ]
            }
        ]
    }
};

export const SubstrateScopeHierarchies = [
    SubstrateLogicalScopeHierarchy,
    SubstratePhysicalScopeHierarchy,
    SubstrateCafeScopeHierarchy,
    SubstrateAccountForestScopeHierarchy
];
